export const config = {
  create: 'Create time work is successfully',
  createFail: 'Create time work is fail',
  update: 'Update time work is successfully',
  updateFail: 'Update time work is fail',
}
